export const scrollToElement = (element) => {
  element.scrollIntoView({
    block: "start",
    behavior: "smooth",
  });
};
